// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.doccontainer1 {
    margin: 0 auto;
    text-align: center;
    padding: 1% 3%;
    background-color: white;
    border-radius: 6px;
    width: 80%;
}

.Viewdata {
    padding: 10px;
    text-align: left;
}

.data_heading {
    font-size: 23px;
}

.ckedit_button {
    background-color: var(--brand-primary);
    color: #fff;
    padding: 8px 12px;
    width: 30%;
    border-radius: 5px;
    cursor: pointer;
    border: none;
    transition: background-color 0.3s ease;
    margin: 10px 5px;
}

.ck.ck-editor__editable_inline {
    border: 1px solid #ccced1 !important;
}

.view_button {
    margin: 10px 0;
    padding: 2px 5px;
    color: var(--red);
    border: 1px solid var(--brand-primary);
    width: 150px;
    display: flex;
    align-items: center;
    gap: 5px;
    cursor: pointer;
}

.languageoptionswithdoc {
    display: flex;
    width: 88%;
    margin: 20px auto;
    gap: 10px
}

.languageoptions {
    display: flex;
    justify-content: space-evenly;
    background-color: white;
    width: 80%;
    margin: 10px auto;
    margin-top: 50px;

}

.active_profile {
    border-bottom: 2px solid var(--brand-primary) !important;
}

.active_profile>a {
    color: var(--brand-primary) !important
}

.languageoptions>li {
    /* width: 24.5%; */
    text-align: center;
    list-style-type: none;
    padding: 15px 0;


}

.languageoptions>li>a {
    width: 100%;
    text-decoration: none;
    color: black
}

@media(max-width:1250px) {
    .languageoptionswithdoc {
        width: 93%;
    }
}

@media(max-width:950px) {
    .languageoptionswithdoc {
        width: 96%;
    }

    .languageoptions {
        font-size: 12px;

    }
}`, "",{"version":3,"sources":["webpack://./src/pages/admin/About Us/About.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,kBAAkB;IAClB,cAAc;IACd,uBAAuB;IACvB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,sCAAsC;IACtC,WAAW;IACX,iBAAiB;IACjB,UAAU;IACV,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,sCAAsC;IACtC,gBAAgB;AACpB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,sCAAsC;IACtC,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,UAAU;IACV,iBAAiB;IACjB;AACJ;;AAEA;IACI,aAAa;IACb,6BAA6B;IAC7B,uBAAuB;IACvB,UAAU;IACV,iBAAiB;IACjB,gBAAgB;;AAEpB;;AAEA;IACI,wDAAwD;AAC5D;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;;;AAGnB;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB;AACJ;;AAEA;IACI;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,UAAU;IACd;;IAEA;QACI,eAAe;;IAEnB;AACJ","sourcesContent":[".doccontainer1 {\n    margin: 0 auto;\n    text-align: center;\n    padding: 1% 3%;\n    background-color: white;\n    border-radius: 6px;\n    width: 80%;\n}\n\n.Viewdata {\n    padding: 10px;\n    text-align: left;\n}\n\n.data_heading {\n    font-size: 23px;\n}\n\n.ckedit_button {\n    background-color: var(--brand-primary);\n    color: #fff;\n    padding: 8px 12px;\n    width: 30%;\n    border-radius: 5px;\n    cursor: pointer;\n    border: none;\n    transition: background-color 0.3s ease;\n    margin: 10px 5px;\n}\n\n.ck.ck-editor__editable_inline {\n    border: 1px solid #ccced1 !important;\n}\n\n.view_button {\n    margin: 10px 0;\n    padding: 2px 5px;\n    color: var(--red);\n    border: 1px solid var(--brand-primary);\n    width: 150px;\n    display: flex;\n    align-items: center;\n    gap: 5px;\n    cursor: pointer;\n}\n\n.languageoptionswithdoc {\n    display: flex;\n    width: 88%;\n    margin: 20px auto;\n    gap: 10px\n}\n\n.languageoptions {\n    display: flex;\n    justify-content: space-evenly;\n    background-color: white;\n    width: 80%;\n    margin: 10px auto;\n    margin-top: 50px;\n\n}\n\n.active_profile {\n    border-bottom: 2px solid var(--brand-primary) !important;\n}\n\n.active_profile>a {\n    color: var(--brand-primary) !important\n}\n\n.languageoptions>li {\n    /* width: 24.5%; */\n    text-align: center;\n    list-style-type: none;\n    padding: 15px 0;\n\n\n}\n\n.languageoptions>li>a {\n    width: 100%;\n    text-decoration: none;\n    color: black\n}\n\n@media(max-width:1250px) {\n    .languageoptionswithdoc {\n        width: 93%;\n    }\n}\n\n@media(max-width:950px) {\n    .languageoptionswithdoc {\n        width: 96%;\n    }\n\n    .languageoptions {\n        font-size: 12px;\n\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
